/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('AdministrationUserEdit', function($rootScope, $scope, $http, $q, _$toast, _$breadcrumbs, $location, $stateParams, userService) {

    $scope.userId = $stateParams.id;

    $scope.user = {};
    $scope.priviledges = [];
    $scope.disabled = {
        "admin": false,
        "unit": false,
        "subunit": false
    };

    $scope.setRead = function(item, symbol) {
        if (symbol == 'w')
            item.read = item.write ? item.write : item.read;
        if (symbol == 'r')
            item.write = item.read ? item.write : item.read;

        if (item.symbol == 'admin'){
          if(item.write) {
            item.read = true;
            for (var i in $scope.priviledges) {
                if ($scope.priviledges[i].symbol == 'administration')
                    continue;
                $scope.priviledges[i].read = true;
                $scope.priviledges[i].write = true;
            }
          }else{
            item.read = false;
          }
        }
    };

    $scope.save = function() {
        $scope.user.priviledges = {};
        for (var i in $scope.priviledges) {
            $scope.user.priviledges[$scope.priviledges[i].id] = {
                read: $scope.priviledges[i].read,
                write: $scope.priviledges[i].write
            };
        }
        $http.post('/administration/users/save', $scope.user)
            .success(function(result) {
                $location.path('/app/administration/users');
                if ($scope.action == 'new')
                    _$toast.success('Uzytkownik został dodany');
                else _$toast.success('Edycja użytkownika zakończyła się pomyślnie');
            });
    };

    $scope.resetPassword = function() {
        $http.get('/administration/users/resetpass/' + $scope.user.id)
            .success(function() {
                _$toast.message('Do użytkownika zostało wysłane nowe hasło');
            });
    };

    $scope.checkForm = function(form) {
        if (form.$valid) {
            return true;
        } else {
            angular.forEach(form.$error, function(field) {
                angular.forEach(field, function(f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });
            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            return false;
        }
    };

    $scope.delete = function() {
        $http.get('/administration/users/delete/' + $scope.user.id)
            .success(function() {
                _$toast.message('Użytkonik został usunięty z systemu');
                $location.path('/app/administration/users');
            });
    };

    $scope.getUser = function() {
        var p = $q.defer();

        if (!_.isUndefined($stateParams.id)) {
            $http.get('/administration/users/get/' + $stateParams.id)
                .success(function(user) {
                    _$breadcrumbs.push(user.name + ' ' + user.surname);
                    $scope.user = user;
                    $scope.user.unit = user.unit_id;
                    $scope.user.subunit = user.subunit_id;
                    p.resolve();
                });
        } else
            p.resolve();
        return p.promise;
    };

    $scope.activate = function() {
        var promise = userService.activate([$scope.user.id]);
        promise.success(function() {
            $scope.user.active = 1;
            _$toast.message('Użytkonik został aktywowany');
        });
    };

    $scope.deactivate = function() {
        var promise = userService.deactivate([$scope.user.id]);
        promise.success(function() {
            $scope.user.active = 0;
            _$toast.message('Użytkonik został dezaktywowany');
        });
    };

    $scope._init = function() {
        $scope.action = $stateParams.action;
        if ($scope.action == 'new') {
            _$breadcrumbs.push('Dodawanie użytkownika');
        }

        $q.all([
            $http.get('/administration/users/priviledges'),
            $http.post('/administration/unit/getlist', {
                subunit: false
            }),
            $http.post('/administration/unit/getlist', {
                subunit: true
            }),
            $scope.getUser()
        ]).then(function(values) {
            $scope.priviledges = values[0].data;

            if (!_.isUndefined($stateParams.id)) {
                for (var i in $scope.priviledges) {
                    var tmp;

                    for (var j in $scope.user.priviledges) {
                        if ($scope.user.priviledges[j].id == $scope.priviledges[i].id)
                            tmp = $scope.user.priviledges[j];
                    }

                    //var tmp = _.findWhere($scope.user.priviledges, {id: $scope.priviledges[i].id});
                    if (_.isUndefined(tmp))
                        continue;
                    $scope.priviledges[i].write = tmp.pivot.write == 1;
                    $scope.priviledges[i].read = tmp.pivot.read == 1;
                }
            }

            $scope.units = values[1].data;
            $scope.subunits = values[2].data;
        });
    };
    $scope._init();

    $scope.$watch('user.subunit', function() {
        if ((typeof $scope.user.subunit == "string" && $scope.user.subunit != "null") || typeof $scope.user.subunit == "number") {
            for (var i = 0; i < $scope.priviledges.length; i++) {
                if ($scope.priviledges[i].symbol != 'message') {
                    $scope.priviledges[i].read = false;
                    $scope.priviledges[i].write = false;
                }
            }
            $scope.disabled.admin = true;
            $scope.disabled.unit = true;
            $scope.disabled.subunit = false;
        } else {
            $scope.disabled.admin = false;
            $scope.disabled.unit = false;
            $scope.disabled.subunit = false;
        }
    });

    $scope.$watch('user.unit', function() {
        if ((typeof $scope.user.unit == "string" && $scope.user.unit != "null") || typeof $scope.user.unit == "number") {
            $scope.disabled.unit = false;
            $scope.disabled.subunit = true;
        } else if (typeof $scope.user.subunit != "number") {
            $scope.disabled.unit = false;
            $scope.disabled.subunit = false;
        }
    });
});
